import * as React from "react";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, children, className }: PageHeaderProps) {
  return (
    <header
      className={cn(
        "flex items-center justify-between",
        "mb-6 pb-4",
        "border-b border-slate-200/80 dark:border-slate-800/80",
        className
      )}
    >
      <div className="flex items-baseline gap-3">
        <h1 className="font-serif text-3xl text-slate-900 dark:text-slate-100 tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <span className="text-sm text-slate-500 dark:text-slate-400 font-medium">
            {subtitle}
          </span>
        )}
      </div>
      {children && (
        <div className="flex items-center gap-4">
          {children}
        </div>
      )}
    </header>
  );
}
